// extracted by mini-css-extract-plugin
module.exports =  {"bottom":"p849V9Ibd1OaADUBfNBI","buildingButton":"ZTv_4QtBlvS6uYWhCyl9"};